import script from "./RefusalFormView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RefusalFormView.vue?vue&type=script&lang=ts&setup=true"

import "./RefusalFormView.vue?vue&type=style&index=0&id=4b4bf9a0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4bf9a0"]])

export default __exports__